/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Huu Khang Nguyen
 * Created: 23/02/22
 */

import { Workplan, WorkplanStage } from '@/wpt-lib/interfaces/Workplan';
import { Comment } from '@/wpt-lib/interfaces/Comment';

export enum WorkplanCommentSection {
    ACTIVITY = 'ACTIVITY',
    LEAVE = 'LEAVE',
    PERSONAL_GOAL = 'PERSONAL_GOAL',
    HEALTH_AND_SAFETY_TRAINING = 'HEALTH_AND_SAFETY_TRAINING',
    CONSIDERATION = 'CONSIDERATION',
    BEHAVIOURAL = 'BEHAVIOURAL',
    END_YEAR = 'END_YEAR',
    END_YEAR_SUPERSEDED = 'END_YEAR_SUPERSEDED',
}

export interface WorkplanComment extends Comment {
    workplan: Workplan;
    section?: WorkplanCommentSection;
    stage?: WorkplanStage;
}

export const mapWorkplanCommentSectionToLabel: Record<WorkplanCommentSection, string> = {
    ACTIVITY: 'Activity',
    LEAVE: 'Planned Leave',
    PERSONAL_GOAL: 'Goals',
    HEALTH_AND_SAFETY_TRAINING: 'Training',
    CONSIDERATION: 'Consideration',
    BEHAVIOURAL: 'Behavioural',
    END_YEAR: 'End Of Year',
    END_YEAR_SUPERSEDED: 'Superseded End of Year',
};
